$(document).ready(function(){
$('.vr-multicolmn-with-modal__blocks').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.vr-multicolumn__prev-arrow'),
    nextArrow: $('.vr-multicolumn__next-arrow'),
	autoplay: false,

    responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
		{
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
   });
});